<template>
  <Drawer title="Basket Actions" screen="searchPage" position="right">
    <template #drawer-header>
      <BasketWithCount/>
    </template>

    <OpenBasketButton/>
    <SplitDocumentsButton/>
    <DxAccordion :selected-index="-1"
                 :collapsible="true"
                 :multiple="false"
                 :width="250"
                 :focus-state-enabled="false"
    >
      <DxAccordionItem title="Edit Tags">
        <TagEditor :show-counts="true"
                   :mode-params="modeParams"
                   :on-submit-tag-edits="editTags"
                   :tag-editor-items="tagEditorItems"
                   :affected-count="basketCount"/>
      </DxAccordionItem>
      <DxAccordionItem title="Mass Update Metadata">
        <MetadataEditor :mode-params="modeParams"
                        :on-submit-metadata-edits="editMetadata"
                        :disabled="basketCount <= 0"
        />
      </DxAccordionItem>
    </DxAccordion>

    <template #drawer-footer>
      <div class="footer-buttons">
        <DrawerFooterButton text="Empty Basket"
                            icon="clear"
                            @click="searchPageStore.emptyBasket()"
        />
      </div>
    </template>
  </Drawer>
</template>

<script setup>
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import Drawer from "@/components/base-components/drawer/Drawer.vue";
  import BasketWithCount from "@/components/search-page/basket-action-drawer/BasketWithCount.vue";
  import OpenBasketButton from "@/components/search-page/basket-action-drawer/OpenBasketButton.vue";
  import SplitDocumentsButton from "@/components/search-page/basket-action-drawer/SplitDocumentsButton.vue";
  import TagEditor from "@/components/base-components/drawer-tools/TagEditor.vue";
  import MetadataEditor from "@/components/base-components/drawer-tools/MetadataEditor.vue";
  import DrawerFooterButton from "@/components/base-components/drawer/DrawerFooterButton.vue";
  import { DxAccordion, DxItem as DxAccordionItem } from "devextreme-vue/accordion";
  import { useCabinetStore } from "~/stores/cabinetStore.js";
  import { useUserStore } from "~/stores/userStore.js";
  import { useSearchPageStore } from "@/stores/searchPageStore.js";

  const cabinetStore = useCabinetStore()
  const { cabinetId } = storeToRefs(cabinetStore)

  const userStore = useUserStore()
  const { userId } = storeToRefs(userStore)

  const searchPageStore = useSearchPageStore()
  const { editTags, editMetadata } = searchPageStore
  const { tagEditorItems, basketCount } = storeToRefs(searchPageStore)

  const modeParams = computed(() => ({
    mode: 'user_selections',
    user_id: userId.value,
    cabinet_id: cabinetId.value
  }))
</script>

<style scoped lang="scss">
  .footer-buttons {
    display: flex;
    flex-direction: column;
  }
</style>
